import api from "../api";

export const getAircrafts = (params) =>
  api.get("/aircrafts", { params });

export const addAircraft = (payload) => api.post("/aircrafts/add", payload);

export const updateAircraft = (id, payload) =>
  api.post(`/aircrafts/edit/${id}`, payload);

export const deleteAircraft = (id) =>
  api.post(`/aircrafts/delete/${id}`);

export const changeAircraftStatus = (id, active) =>
  api.post(`/aircrafts/change_status/${id}`, { active });

